import { ChangeDetectorRef, Component, ElementRef, HostListener, Input,OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalDismissReasons, NgbActiveModal, NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { NgbdSortableHeader, SortEvent } from '../../../../../Autofacets-Core/src/app/directives/sortable.directive';
import { ApplicationSource } from '../../business-entities/application-source';
import { CityModel, CustomerDetailsViewModel, CustomerDiscount } from '../../business-entities/customer-view.model';
import { DMSSyncFailedLogRequestModel } from '../../business-entities/dmssyncfailedlog-request-model';
import { Filter } from '../../business-entities/Filter';
import { PagerData } from '../../business-entities/PagerData';
import { DeleteAdvanceSearchFilterModel, SaveAdvanceSearchFilterModel, SearchArrayModel } from '../../business-entities/save-advance-search-filter';
import { SelectListItemViewModel } from '../../business-entities/select-list-item-view-model';
import { StatusViewModel } from '../../business-entities/status-view-model';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { AdvanceSearchService } from '../../business-services/advance-search.service';
import { ApplicationSourceService } from '../../business-services/application-source.service';
import { CustomerService } from '../../business-services/customer.service';
import { DashboardService } from '../../business-services/dashboard.service';
import { DMSSyncFailedlogService } from '../../business-services/dms-sync-failed-log.service';
import { SavedSearchComponent } from '../../components/saved-search/saved-search.component';
import { PaginationService } from '../../services/pagination.service';
import * as Enums from './../../../../../Autofacets-Core/src/app/utils/enums';
import { FeatureCode } from './../../../../../Autofacets-Core/src/app/utils/enums';
import { CustomerListRequestModel } from '../../business-entities/customerList-request-model';
import { DealerBusinessService } from '../../business-services/dealer.service';
import { UserDealersModel } from '../../business-entities/dealer-details.model';
import { DealerServiceBusinessService } from '../../business-services/dealer-service.service';


@Component({
  selector: 'app-deleted-customer',
  templateUrl: './deleted-customer.component.html'
 
})
export class DeletedCustomerComponent implements OnInit {

  isAdvanceSearch: any;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  customerSub: Subscription;
  customerPDFSub: Subscription;
  closeResult: string;
  closeModel: any;
  customerListExcel: CustomerDetailsViewModel[];
  customerList: CustomerDetailsViewModel[] = [];
  customerListPDF: CustomerDetailsViewModel[];
  customerDiscount: CustomerDiscount = {
    id: 0,
    comment: '',
    discount: 0
  }
  userRoleRightsDetails: UserRoleMenu;
  isView: boolean = false;

  pager: any = {};
  totalCount: number = 0;
  pagerData: PagerData = {
    page: 1,
    pagerSize: 25//Constant.GridPagerSize
  }
  dataRows: any[] = [];
  filter: Filter = new Filter();
  filterItems: any[];
  pagedItems: any[];
  searchTerm: string;
  popupCloseResult = false;
  currentUser: string;
  customerGroupList: any;
  addressSalutationList: any;
  applicationSourceList: Array<SelectListItemViewModel>;
  postCodeList: any;
  postCodeRawData: any;
  cityList: CityModel[];
  selectedItems = [];
  companyShow: boolean = false;
  saveSearchFilter: SaveAdvanceSearchFilterModel = {
    filterName: null,
    moduleId: Enums.ModuleNames.Customer,
    saveSearchArray: []
  };
  deleteSearchFilter: DeleteAdvanceSearchFilterModel = {
    filterName: null,
    moduleId: Enums.ModuleNames.Customer,
  };
  dropdownSettings = {};
  savedSearchListResponse: SaveAdvanceSearchFilterModel[] = [];
  integrationWithDMS: boolean = false;
  control = new FormControl();
  SyncList: StatusViewModel[] = [];
  StatusList: StatusViewModel[] = [];
  selectedStatus: number;
  selectedSync: number;
  IsDMS: boolean;
  subscription: Subscription;
  dealerList: Array<SelectListItemViewModel>;
  selectedDealerId: string = '';
  dmsLogRequestModel: DMSSyncFailedLogRequestModel =
    {
      startRecordNumber: 0,
      pageSize: 25,
      sortColumn: '',
      sortDirection: '',
      moduleId: Enums.ModuleNames.Customer,
      logDate: '',
      referenceId: 0
    };
  customerListRequest: CustomerListRequestModel =
    {
      searchTerm: '',
      startRecordNumber: 0,
      pageSize: 25,
      sortColumn: '',
      sortDirection: '',
      isForDocuments: false,
      customerTypeId: 0,
      customerName: '',
      firstName: '',
      lastName: '',
      customerNo: '',
      customerGroup: null,
      salutation: null,
      postCode: null,
      city: null,
      email: '',
      mobile: '',
      licensePlateNo: '',
      statusId: 0,
      syncId: 0,
      sourceOfCreation: '',
      dealerName: '',
      isDeleted: true,
      dealerId:''
    }
  allowCompanyCreation: boolean;
  allowAccount: boolean;
  allowQuickSearch: boolean;
  @ViewChild('htmlData1') htmlData: ElementRef;

  @Input() fromVehicleScreen: any = false;
  @Input() customerNo: any;
  selectedCustomerId: any = null;

  throttle = 100;
  scrollDistance = 1;

  constructor(
    private service: CustomerService,
    private advanceSearchService: AdvanceSearchService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    private userService: UserDataService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    public dealerBusinessService: DealerBusinessService,
    private currentLanguageService: CurrentLanguage,
    private dashboardService: DashboardService,
    private applicationSourceService: ApplicationSourceService,
    private dealerServiceBusinessService: DealerServiceBusinessService,
    private activeModal: NgbActiveModal,
    private secureStorage: SecureStorage,
    private _eref: ElementRef,
    config: NgbModalConfig
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit(): void {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'value',
      textField: 'text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
      searchPlaceholderText: 'Search here',
      maxHeight: 500
    };
    this.StatusList = this.dashboardService.getStatusList();
    this.SyncList = this.dashboardService.getDmsStatusList();
    this.userService.currentUserSubject.subscribe((res)=>{
      if (res) {
        this.userRoleRightsDetails = (res.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.CustomerDelete); 
      }
    });
    this.getFeatures();
    this.getUserDealers();

    this.customerListRequest.startRecordNumber = 0;
    this.customerList = []
  }

  resetVariables() {
    this.companyShow = false;
    this.customerListRequest.customerTypeId = 0;
    this.customerListRequest.firstName = '';
    this.customerListRequest.lastName = '';
    this.customerListRequest.customerName = '';
    this.customerListRequest.customerNo = '';
    this.customerListRequest.customerGroup = null;
    this.customerListRequest.salutation = null;
    this.customerListRequest.postCode = null;
    this.customerListRequest.city = null;
    this.customerListRequest.email = '';
    this.customerListRequest.mobile = '';
    this.customerListRequest.licensePlateNo = '';
    this.customerListRequest.sourceOfCreation = '';
    this.customerListRequest.dealerName = '';
    this.selectedDealerId = null;
    this.customerListRequest.dealerId = null;
    this.selectedItems = [];

    this.customerListRequest.startRecordNumber = 0;
    this.customerList = []
  }
  onReset() {
    this.resetVariables();
    this.getCustomerList();
  }
  onClose() {
    this.isAdvanceSearch = false;
  }
  onSearch() {
    if (this.customerGroupList == undefined) {
      this.getCustomerGroup();
    }
    if (this.postCodeRawData == undefined) {
      this.getPostCodeDropdown();
    }
    if (this.applicationSourceList == undefined) {
      this.GetApplicationSource();
    }
    this.cdr.detectChanges();
    this.isAdvanceSearch = true;
    this.cdr.detectChanges();
  }

  onApplyFilter() {
    this.AdvanceSearchSubmit();
  }

  AdvanceSearchSubmit() {

    this.customerListRequest.sourceOfCreation = "";
    if (this.selectedItems.length > 0) {
      this.customerListRequest.sourceOfCreation = this.selectedItems.map(x => x.value).join(',')
    }
    this.customerListRequest.searchTerm = this.searchTerm;
    this.customerListRequest.customerTypeId = this.companyShow ? 2 : 1;
    this.customerListRequest.dealerId = this.selectedDealerId;
    this.customerListRequest.startRecordNumber = Constant.startRecordNumber;
    this.customerList = []
    this.getCustomerList();
    this.isAdvanceSearch = false;
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.customerListRequest.sortColumn = column;
    this.customerListRequest.sortDirection = direction;
    this.customerListRequest.startRecordNumber = 0;
    this.customerList = []
    this.getCustomerList();
  }

  onSearchFilter() {
    this.customerListRequest.startRecordNumber = 0;
    this.customerListRequest.searchTerm = this.searchTerm;
    this.customerList = []
    this.getCustomerList();
  }

  onRefresh() {
    this.customerListRequest.startRecordNumber = 0;
    this.customerList = []
    this.getCustomerList();
  }

  async GetApplicationSource(): Promise<void> {
    await this.applicationSourceService.getApplicationSource().then(data => {
      this.applicationSourceList = this.mapdealer(data.responseObject);
    });
  }


  mapdealer(array: ApplicationSource[]) {
    let supperArray = [];
    if (array && array.length > 0) {

      array.forEach(element => {
        let single = Object();
        single.value = element.sourceId
        single.text = element.sourceName

        supperArray.push(single);
      })
    }
    return supperArray;
  }

  async getFeatures() {
    let features = this.secureStorage.getKeyData('feature');
    if (features == null || features == undefined) {
      this.subscription = this.currentLanguageService.featureList.subscribe((res) => {
        features = res;
        if (features?.length > 0) {
          this.getCustomers(features);
        }
      })
    }
    else {
      this.getCustomers(features);
    }
  }
  getCustomers(features: any) {
    this.integrationWithDMS = features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
    this.allowCompanyCreation = features.find(x => x.featureCode === FeatureCode.AllowCompanyCreation)?.isActive;
    this.allowAccount = features.find(x => x.featureCode === FeatureCode.AllowAccount)?.isActive;
    this.allowQuickSearch = features.find(x => x.featureCode === FeatureCode.AllowQuicksearch)?.isActive;
    this.IsDMS = features.find(x => x.featureCode === FeatureCode.DMS)?.isActive;
    this.getCustomerList();
  }
  async getCustomerGroup() {
    this.spinner.show();
    await this.service.GetCustomerGroupDropdown().then((response) => {
      this.customerGroupList = response.responseObject.filter(x => x.isDisplay);
      this.customerGroupList = this.customerGroupList.sort((a, b) =>
        (b?.code || '').localeCompare(a?.code || '')
      );
      this.spinner.hide();
    }, _error => {
      this.spinner.hide()
    });

  }

  async getAddressSalutationDropdown() {
    this.spinner.show();
    await this.service.GetAddressSalutationDropdown().then((response) => {
      this.addressSalutationList = response != null ? response.responseObject : [];
      this.spinner.hide();
    }, _error => {
      this.spinner.hide()
    });
  }

  async getPostCodeDropdown() {
    this.spinner.show();
    let postCodes = this.secureStorage.getKeyData('postCodes');
    if (postCodes) {
      this.postCodeRawData = postCodes;
      this.BindPostData("");
      this.BindCityData("");
    } 
    this.spinner.hide();
  }

  BindPostData(city) {
    if (city?.trim()) {
      this.postCodeList = this.postCodeRawData.filter(f => f.city == city);
    } else {
      this.postCodeList = this.postCodeRawData;
    }
  }

  BindCityData(post) {
    if (post?.trim()) {
      let postdata = this.postCodeRawData.filter(f => f.code == post);
      this.cityList = postdata.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
      this.onCitySelected(this.cityList[0])
    } else {
      this.cityList = this.postCodeRawData.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
    }
  }

  async onPostCodeSelected(postCode: string) {
    this.customerListRequest.postCode = postCode;
    if (postCode?.trim()) {
      this.BindCityData(postCode);
    } else {
      this.postCodeList = this.postCodeRawData;
      this.customerListRequest.city = "";
    }
  }

  async onCitySelected(city: any) {
    this.customerListRequest.city = city;
    if (city?.trim()) {
      this.BindPostData(city);
    } else {
      this.cityList = this.postCodeRawData.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
      this.customerListRequest.postCode = "";
    }
  }

  changeCustomerType(event: Event) {
    this.companyShow = (event.target as HTMLInputElement).checked;
  }
  
  // Change the status active - inactive
  StatusChange(status: any) {
    if (status == undefined) {
      this.customerListRequest.statusId = Enums.StatusCode.All;
    } else {
      this.customerListRequest.statusId = status;
    }
    this.customerListRequest.startRecordNumber = 0;
    this.customerList = [];
    this.getCustomerList();
  }

  onScrollDown(_ev) {
    if (this.totalCount > this.customerList.length) {
      this.customerListRequest.startRecordNumber = this.customerList.length;
      this.getCustomerList();
    }
  }

  //Customer listing method
  async getCustomerList() {
    this.spinner.show();
    await this.service.getCustomerList(this.customerListRequest).then((response) => {
      this.spinner.hide();
      this.customerList.push(...this.customerDataMapper(response.responseObject.customerList));
      if (response.responseObject?.result?.errorCode == "5449") {
        this.totalCount = 0;
      }
      else {
        this.totalCount = this.customerList.length > 0 ? this.customerList[0].totalCount : 0;
      }
    }, _error => {
      this.spinner.hide()
    });
  }

  // map customer data
  private customerDataMapper(customer: any) {
    let supperArray = [];
    if (customer && customer.length > 0) {

      for (let index = 0; index < customer.length; index++) {
        const element = customer[index];

        let single = Object();
        single.rowNumber = (this.customerListRequest.startRecordNumber + 1) + index;
        single.id = element.id
        single.customerId = element.customerId
        single.customerName = element.customerName
        single.addressLine1 = element.addressLine1
        single.addressLine2 = element.addressLine2
        single.city = element.city
        single.state = element.state
        single.country = element.country
        single.email = element.email
        single.mobileNo = element.mobileNo
        single.mobileCode = element.mobileCode
        single.discount = element.discount
        single.comment = element.comment
        single.noOfVehicle = element.noOfVehicle
        single.customerType = element.customerType
        single.firstName = element.firstName
        single.lastName = element.lastName
        single.sourceType = element.sourceType
        single.isActive = element.isActive
        single.activeStatus = element.activeStatus
        single.customerNo = element.customerNo
        single.pincode = element.pincode
        single.dmsSyncStatus = element.dmsSyncStatus
        single.updatedDate = element.updatedDate ? new Date(element.updatedDate + 'Z') : null;
        single.dmsSyncDate = element.dmsSyncDate ? new Date(element.dmsSyncDate + 'Z') : null;
        single.createdDate = element.createdDate ? new Date(element.createdDate + 'Z') : null;
        single.totalCount = element.totalCount
        single.preferredDealerName = element.preferredDealerName
        supperArray.push(single);
      }
    }
    return supperArray;
  }


  // models method
  open(content, id) {
    let record = this.customerList.find(x => x.id === id);
    this.customerDiscount.id = id
    this.customerDiscount.comment = record.comment
    this.customerDiscount.discount = record.discount
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  private getDismissDeleteReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }

  ngOnDestroy(): void {
    if (this.customerSub) {
      this.customerSub.unsubscribe();
    }
    if (this.customerPDFSub) {
      this.customerPDFSub.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.customerListRequest.searchTerm = null
    this.dashboardService.isFromDashboard = false;
  }

  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }

  // open Save Search model
  OpenSaveSearchModal(content) {
    this.saveSearchFilter.saveSearchArray = [];
    this.control = new FormControl();
    this.createSaveSearchModel();
    if (this.saveSearchFilter.saveSearchArray.length > 0) {
      this.closeModel = this.modalService.open(content, { size: 'xl', ariaLabelledBy: 'modal-basic-title' });
        this.closeModel.result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }
    else {
      let ErrorMsg = this.translate.instant("lblPleaseFillAtleastOneField");
      this.toastr.error(ErrorMsg);
    }
  }

  // Save Search model
  createSaveSearchModel() {
    this.saveSearchFilter.filterName = null;
    this.saveSearchFilter.moduleId = Enums.ModuleNames.Customer;
    this.customerListRequest.customerTypeId = this.companyShow ? 2 : 1;
    this.customerListRequest.sourceOfCreation = "";
    if (this.selectedItems.length > 0) {
      this.customerListRequest.sourceOfCreation = this.selectedItems.map(x => x.value).join(',')
    }
    if (this.customerListRequest.customerTypeId > 0) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblCompany",
        searchValue: this.customerListRequest.customerTypeId == 2 ? "Company" : "Individual",
        searchActualValue: this.customerListRequest.customerTypeId == 2 ? "Company" : "Individual",
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }

    if (this.customerListRequest.customerName) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblName",
        searchValue: this.customerListRequest.customerName,
        searchActualValue: this.customerListRequest.customerName
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.customerListRequest.customerNo) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblCustomerNumber",
        searchValue: this.customerListRequest.customerNo,
        searchActualValue: this.customerListRequest.customerNo
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.customerListRequest.customerGroup) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblCustomerGroup",
        searchValue: this.customerListRequest.customerGroup,
        searchActualValue: this.customerListRequest.customerGroup
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.customerListRequest.salutation) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblSalutation",
        searchValue: this.customerListRequest.salutation,
        searchActualValue: this.customerListRequest.salutation
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.customerListRequest.postCode) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblPostCode",
        searchValue: this.customerListRequest.postCode,
        searchActualValue: this.customerListRequest.postCode
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.customerListRequest.city) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblCity",
        searchValue: this.customerListRequest.city,
        searchActualValue: this.customerListRequest.city
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.customerListRequest.email) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblEmail",
        searchValue: this.customerListRequest.email,
        searchActualValue: this.customerListRequest.email
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.customerListRequest.mobile) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblMobile",
        searchValue: this.customerListRequest.mobile,
        searchActualValue: this.customerListRequest.mobile
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }
    if (this.customerListRequest.licensePlateNo) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblLicensePlate",
        searchValue: this.customerListRequest.licensePlateNo,
        searchActualValue: this.customerListRequest.licensePlateNo
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }

    if (this.customerListRequest.sourceOfCreation) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblSource",
        searchValue: this.selectedItems.map(x => x.text).join(','),
        searchActualValue: this.selectedItems.map(x => x.text).join(',')
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }

    if (this.customerListRequest.dealerName) {
      let searchModel: SearchArrayModel =
      {
        searchColumnName: "lblDealersName",
        searchValue: this.customerListRequest.dealerName,
        searchActualValue: this.customerListRequest.dealerName
      }
      this.saveSearchFilter.saveSearchArray.push(searchModel);
    }

  }

  //Save Advacne Search filter
  SaveAdvanceSearchFilter() {
    if (!this.saveSearchFilter.filterName.replace(/\s/g, "").length) {
      let errorMsg = this.translate.instant("lblSearchNameRequired");
      this.toastr.error(errorMsg);
      return;
    }
    this.advanceSearchService.SaveAdvanceSearchFilter(this.saveSearchFilter).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode && response.responseObject === true) {
        let successMsg = this.translate.instant("lblSearchFilteredSaved");
        this.toastr.success(successMsg);
        this.closeModel.close();
      }
      else {
        let errorMsg = this.translate.instant("lblSaveSearchFilterNameAlreadyExists");
        this.toastr.error(errorMsg);
      }
    });
  }

  OpenSavedSearchListPopup() {
    this.spinner.show();
    this.GetAdvanceSearchList().then((_res) => {
      const modalref = this.modalService.open(SavedSearchComponent, {
        size: 'xl',
        ariaLabelledBy: 'modal-basic-title',
      });
      modalref.componentInstance.isFromAppointment = false;
      modalref.componentInstance.searchList = this.savedSearchListResponse;
      modalref.componentInstance.onReset.subscribe((_data) => {
        this.onReset();
      });
      modalref.componentInstance.onEditOrRun.subscribe((data) => {
        if (data.isRun) {
          this.resetVariables();
        }
        this.ApplySaveSearch(data.searchData, data.isRun);
      });
      modalref.componentInstance.onDelete.subscribe((data) => {
        this.OnDeleteSaveSearch(data, modalref);
      });
    });
  }
  async GetAdvanceSearchList() {
    await this.advanceSearchService.GetAdvanceSearchList(Enums.ModuleNames.Customer).then(result => {
      if (result) {
        if (result.responseObject.errorCount) {
          this.spinner.hide();
        }
        else {
          this.savedSearchListResponse = result.responseObject;
          this.savedSearchListResponse.forEach(element => {
            element.saveSearchArray.forEach(val => {
              val.searchActualValue = val.searchValue;
            });
          });
        }
      }
      this.spinner.hide();
    },
      _error => {
        this.spinner.hide()
      });
  }

  OnDeleteSaveSearch(searchName, outerModalRef) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblSavedFilters"), true);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissDeleteReason(reason);
      if (this.popupCloseResult) {
        this.deleteSearchFilter.filterName = searchName;
        this.advanceSearchService.DeleteAdvanceSearch(this.deleteSearchFilter).then(response => {
          if (response.responseCode == Constant.SuccessResponseCode && response.responseObject === true) {
            this.GetAdvanceSearchList().then(() => outerModalRef.dismiss());
            let msg = this.translate.instant("lblSaveSearchDeletedSuccessfully");
            this.toastr.success(msg);
          }
          else {
            let msg = this.translate.instant("lblFailedTodeleteSaveSearch");
            this.toastr.error(msg);
          }
        }, error => {
          if (error.status === Constant.BadRequest) {
            let WarningMessage = this.translate.instant("lblErrorWarningForValue")
            this.toastr.warning(WarningMessage);
          }
          else {
            let errorMessage = this.translate.instant("lblErrorMessage");
            this.toastr.error(errorMessage);
          }

        });
      }
    });
  }

  ApplySaveSearch(data, isRunSearch) {
    if (data) {
      let saveSearchDetail = this.savedSearchListResponse.filter(x => x.filterName === data);
      if (saveSearchDetail.length > 0 && saveSearchDetail[0]) {
        saveSearchDetail[0].saveSearchArray.forEach(element => {
          switch (element.searchColumnName) {
            case 'lblCompany':
              this.customerListRequest.customerTypeId = element.searchValue == "Company" ? 2 : 1;
              this.companyShow = this.customerListRequest.customerTypeId == 2 ? true : false;
              break;
            case 'lblFirstName':
              this.customerListRequest.firstName = element.searchValue;
              break;
            case  'lblLastName':
              this.customerListRequest.lastName = element.searchValue;
              break;
            case 'lblCompanyName':
              this.customerListRequest.customerName = element.searchValue;
              break;
            case 'lblCustomerNumber':
              this.customerListRequest.customerNo = element.searchValue;
              break;
            case 'lblCustomerGroup':
              this.customerListRequest.customerGroup = element.searchValue;
              break;
            case 'lblSalutation':
              this.customerListRequest.salutation = element.searchValue;
              break;
            case 'lblPostCode':
              this.customerListRequest.postCode = element.searchValue;
              break;
            case 'lblCity':
              this.customerListRequest.city = element.searchValue;
              break;
            case 'lblEmail':
              this.customerListRequest.email = element.searchValue;
              break;
            case 'lblMobile':
              this.customerListRequest.mobile = element.searchValue;
              break;
            case 'lblLicensePlate':
              this.customerListRequest.licensePlateNo = element.searchValue;
              break;
            case 'lblDealersName':
              this.customerListRequest.dealerName = element.searchValue;
              break;
            case 'lblSource':
              let sourceStr = element.searchValue.split(",");
              if (this.applicationSourceList && sourceStr) {
                this.applicationSourceList.forEach(x => {
                  sourceStr.forEach(y => {
                    if (x.text === y) {
                      this.selectedItems.push(x);
                    }
                  })
                })
              }

              this.customerListRequest.sourceOfCreation = this.selectedItems.map(x => x.value).join(',');
              break;
            default:
              break;
          }
        });
      }
      if (isRunSearch) {
        this.AdvanceSearchSubmit();
      }
      else {
        this.onSearch();
        this.activeModal.dismiss();
      }
    }
  }

  async getUserDealers() {
    await this.dealerBusinessService.getUserDealersDropdown().then((response) => {
      this.dealerList = this.mapdealers(response.userDealersModel);
      this.dealerBusinessService.dealerList = this.dealerList;
      if(this.dealerList.length===1)
      {
        this.selectedDealerId = response.userDealersModel[0].dealerId;
      }
    })
  }
  
  mapdealers(array: UserDealersModel[]) {
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach(element => {
        let single = Object();
        single.value = element.dealerId
        single.text = element.dealerName

        supperArray.push(single);
      })
    }
    return supperArray;
  }
  onDealerSelected(dealerId: string, flag: string) {
    this.selectedDealerId = dealerId;
    this.dealerServiceBusinessService.dealerId = dealerId;
    if (flag === 'dealerDropdown') {
      this.service.customerListRequest.isAdvanceSearch = false;
      this.getCustomerList();
    }
    else {
      this.service.customerListRequest.isAdvanceSearch = true;
    }
  }

  OnClose() {
    this.activeModal.close({ success: true });
  }
  @HostListener('document:click', ['$event'])
  onSearchBoxClose(event) {
    if (event && (event.target.className.indexOf('ng-option') == -1 && event.target.parentElement.className.indexOf('ng-option') == -1) && event.target.className.indexOf('btn') == -1) {
      if (!this._eref.nativeElement.getElementsByClassName('advanced-search-box')[0]?.contains(event.target)) {
        this.isAdvanceSearch = false;
      }
    }
  }
  async selectedCustomer() {
    let customerDetail = null;
    this.activeModal.close({ success: true, customerId: this.selectedCustomerId });
  }
  //Hard delete customer
  HardDeleteCustomer(id: number) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblHardDeleteCustomer"), false);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissDeleteReason(reason);
      if (this.popupCloseResult) {
        this.currentUser = this.userService.currentUserValue.userId;
        let deleteRequestModel = { id: id, UserId: this.currentUser };
        this.service.HarddeleteCustomer(deleteRequestModel).then((response) => {
          this.customerList = [];
          this.getCustomerList();
          if (response.responseCode == Constant.SuccessResponseCode) {
            let successMsg = this.translate.instant("lblCustomerDeleted");
            this.toastr.success(successMsg)
          }
        });
      }
    })
  }
}

